module.exports = __webpack_public_path__ + "img/pan-tool.1f54010e.svg";